function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6f87a6",
  d: "M109.25 55.5h-36l12-12a29.54 29.54 0 00-49.53 12H18.75A46.04 46.04 0 0196.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0049.53-12h16.97A46.04 46.04 0 0131.1 96.16L18.74 108.5v-36z"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 64 64",
  to: "360 64 64",
  dur: "720ms",
  repeatCount: "indefinite"
}));

function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 128 128"
  }, props), _ref);
}

export default SvgLoader;